import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { CommonHelper } from '../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { MatSnackBar } from '@angular/material';
import { replaceAll } from 'chartist';

@Component({
  selector: 'kt-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent implements OnInit {
  public fileUploader:boolean=false;
  @Output() uploadData = new EventEmitter();
  files: any[] = [];
  private attachmentBase64: string;
  public isAlertVisible:Boolean = false;
  public loader:boolean=false;
  @ViewChild('fileDropRef',{static:false}) fileDropRef: ElementRef;
  public selectedFilePayload:any;
  public userName:any;
  public alertType:string;
  public alertMsgValue:string;
  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt + ',' + HEC_CONSTANTS.CONSTANT_VALUES.fileExtEmail;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public fileData:any;
  public blobImage;
  @Input('processAcronym')processAcronym;
  @Input('category')category;
  @Input('appId')appId;
  @Input('title')title;
  imageName: any;
  
  constructor(private cdr:ChangeDetectorRef,private ng2ImgMax: Ng2ImgMaxService,private loaderService:LoaderService,
    private sharedService:SharedService, private snackbar:MatSnackBar) { }

  ngOnInit() {
    console.log(this.title)
    if(this.title == 'Revision Requested'){
      this.fileExt = HEC_CONSTANTS.CONSTANT_VALUES.desFileExt
    }
  }


  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  async prepareFilesList(e: Array<any>) {
    if(e.length > 1){
      return false;
    }
    let image = e[0];
    let test:File;  
    let file = e[0];
    this.imageName = file.name;
    if (this.isValidFile(file)) {
      this.fileUploader = true;
    this.cdr.detectChanges();
    if (file.type !== 'application/pdf' && file.type !== 'message/rfc822' && file.type !== 'application/vnd.ms-outlook' && file.type !== '' ) {
    this.ng2ImgMax.compressImage(image, 0.575).subscribe(
      async result => {
        test = result;
        this.blobImage = result;
        await this.setAttachmentsPayload(result);

      // this.uploadAttachment();
      // if(this.uploadData == undefined){
        await this.uploadAttachment();
        file=undefined
        this.fileDropRef.nativeElement.value = null
        image = undefined
      // }
      },
      error => {
        console.log(error);
        this.fileUploader = false;
        this.cdr.detectChanges();
      }
    );
    }else{
      // if(this.uploadData == undefined){
        this.blobImage = image;
        await this.setAttachmentsPayload(image);
        await this.uploadAttachment();
        file=undefined
        this.fileDropRef.nativeElement.value = null
        image = undefined
      // }
      
    }
    for (const item of e) {
      item.progress = 0;
      this.files.push(item);
    }
    
    // this.uploadFilesSimulator(0);
  }else{
    e=undefined
    file=undefined
    this.fileDropRef.nativeElement.value = null
  }
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
            this.fileUploader=false;
            this.cdr.detectChanges();
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  private async setAttachmentsPayload(file) {
    console.log(file)
    this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
    console.log("attach doen",this.attachmentBase64 )
  }

  private uploadAttachment() {   

    console.log("upload called")
    return new Promise((resolve, reject) => {
    this.loader=true;
    this.loaderService.setValue(this.loader)
   
    const formData = new FormData();
    formData.append('file', this.blobImage);
    this.imageName = replaceAll(this.imageName,' ','_')

   // this.sharedService.uploadDocument(payload)
   if(this.title == 'Revision Requested')
   {
    this.uploadRevisionRequestedAttachment()
   }
   else
   this.sharedService.uploadAdminDocument(this.processAcronym,this.appId,this.imageName,formData)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            console.log("upload doen")
            this.loader=false;
            this.loaderService.setValue(this.loader)
            //this.fileData = res.data.documentId
            this.files = [];
            this.fileDropRef.nativeElement.value = null
            //payload.data['documentId'] = res.data.documentId
            this.uploadData.emit(this.appId);
            this.isAlertVisible = false;
            resolve(this.uploadData)
          }
          else{
            this.loader=false;
            this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          this.isAlertVisible=true;
          }
        },
        (err) => {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          this.isAlertVisible=true;
        }
      )
    });
  }

  private isValidFile(file) {
    console.log(this.fileExt)
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;
    console.log(extensions, ext)

    if (extensions.indexOf(ext) === -1) {
      this.alertType='warning';
      this.alertMsgValue='Error in uploading ' + file.name + ' due to invalid file type.';
      this.isAlertVisible=true;
      this.sharedService.showError('Error in uploading ' + file.name + ' due to invalid file type.', 'OK', 'error-snackbar');

      // this.alertBoxMsg('Error in uploading ' + file.name + ' due to invalid file type.','warning');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isAlertVisible = false;
        this.cdr.detectChanges();
      }, 6000);   
      // this.msgPopup('Error', 'Error in uploading ' + file.name + ' due to invalid file type.','alert-error-popup')
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.alertType='warning';
      this.alertMsgValue='Invalid File Name';
      this.isAlertVisible=true;
      this.sharedService.showError('Invalid File Name', 'OK', 'error-snackbar');
      // this.alertBoxMsg('Invalid File Name','warning');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isAlertVisible = false;
        this.cdr.detectChanges();
      }, 6000);   
      // this.msgPopup('Error', 'Invalid File Name','alert-error-popup')
      return false;
    } 
    else if (fileSizeinKB > this.maxSize) {
      this.alertType='warning';
      this.alertMsgValue=file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.';
      this.sharedService.showError(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.', 'OK', 'error-snackbar');
     
      this.isAlertVisible=true;
      // this.alertBoxMsg(file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.','warning');
      this.cdr.detectChanges();
      setTimeout(() => {
        this.isAlertVisible=false;
        this.cdr.detectChanges();
      }, 6000);   
      // this.msgPopup('Error', file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.','alert-error-popup')
      return false;
    }
    return true;
  }

  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  deleteFile(index: number) {
    this.files.splice(index, 1);
  }


  private uploadRevisionRequestedAttachment() {   
    return new Promise((resolve, reject) => {
    this.loader=true;
    this.loaderService.setValue(this.loader)
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    console.log(this.imageName)

    let payload = {
      data: {
          applicationId: this.appId,
          addedBy: JSON.parse(localStorage.getItem('login'))['username'],
          content: this.selectedFilePayload,
          processAcronym: this.processAcronym,
          category: this.category,
          title: this.imageName,
          description: this.category,
      }
    }
    console.log(payload)
    this.sharedService.uploadDocument(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.loader=false;
            this.loaderService.setValue(this.loader)
            this.fileData = res.data.documentId
            this.files = [];
            this.fileDropRef.nativeElement.value = null
            payload.data['documentId'] = res.data.documentId
            this.uploadData.emit(payload.data);
            this.isAlertVisible = false;
            resolve(this.uploadData)
          }
          else{
            this.loader=false;
            this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          this.isAlertVisible=true;
          }
        },
        (err) => {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          this.isAlertVisible=true;
        }
      )
    });
  }
}
